import { render, staticRenderFns } from "./Westnet.vue?vue&type=template&id=24102b5e&"
import script from "./Westnet.vue?vue&type=script&lang=js&"
export * from "./Westnet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports